import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"text-h4"},[_vm._v("Manage Persons")]),_c(VDivider,{staticClass:"my-2"}),_c('persons-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }